import type { RedirectRouteRelative } from '@/utilities/routers.ts'

import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeWebhookCreate,
  detail: routeWebhookDetail,
  home: routeWebhookHome,
  root: routeWebhookRoot,
} = createDoctypeRoutes({
  createName: 'new-webhook',
  createPath: 'new-webhook',
  detailName: 'webhookDetail',
  doctype: DOCTYPES.WEBHOOK,
  homeName: 'webhook',
  path: 'webhook',
  views: {
    create: async () => await import('@/components/viewsExternal/webhook/AddWebhook.vue'),
    detail: async () => await import('@/components/viewsExternal/webhook/ViewWebhook.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/interfaces/ViewInterfaces.vue'),
  },
})

const redirectWebhookDetail: RedirectRouteRelative = {
  name: routeWebhookDetail.name,
}

export {
  redirectWebhookDetail,
  routeWebhookCreate,
  routeWebhookDetail,
  routeWebhookHome,
  routeWebhookRoot,
}
